import React, { useRef } from 'react';
import { postOffboadingTemplateData, updateOffboadingTemplateData } from '../../service/adminApi';
import { OnlyNumberSpecialChar } from '../../utils/RegHandling';

function OffboardingTemplateForm({ editData, handleData, hideContainer }) {
    const textarearef = useRef(null);

    let defaultValue = {
        name: '',
        description: '',
    };
    let errorDefaultValue = {
        nameError: '',
        descriptionError: '',
    };
    const [offboardingTemplateDetails, setoffboardingTemplateDetails] = React.useState(defaultValue);
    const [offboardingTemplateError, setoffboardingTemplateErrors] = React.useState(errorDefaultValue);
    const [editId, setEditId] = React.useState();
    const [showNavbar, setShowNavbar] = React.useState(false);
    React.useEffect(() => {
        if (editData !== undefined) {
            setoffboardingTemplateDetails({
                name: editData.name,
                description: editData.description,
            });
            setEditId(editData.id);
        }
    }, [editData]);

    const resetData = () => {
        setoffboardingTemplateDetails(defaultValue);
        setoffboardingTemplateErrors(errorDefaultValue);
        handleData('cancel');
        hideContainer();
    };

    const handleOffboardingTemplateForm = (e) => {
        setoffboardingTemplateDetails((offboardingTemplateDetails) => ({
            ...offboardingTemplateDetails,
            [e.target.name]: e.target.value,
        }));
    };

    const postOffboardingTeamplate = async () => {
        if (validateOffboardingForm()) {
            if (editId === undefined || editId === '') {
                const reponse = await postOffboadingTemplateData(offboardingTemplateDetails);
                if (reponse.data.statusCode === 200) {
                    setoffboardingTemplateDetails(defaultValue);
                    handleData('update');
                    hideContainer();
                }
            } else {
                let data = offboardingTemplateDetails;
                data['id'] = editId;
                const reponse = await updateOffboadingTemplateData(data);
                if (reponse.data.statusCode === 200) {
                    setoffboardingTemplateDetails(defaultValue);
                    handleData('update');
                    hideContainer();
                }
            }
        }
    };

    const validateOffboardingForm = () => {
        let validate = true;
        if (
            offboardingTemplateDetails.name === undefined ||
            offboardingTemplateDetails.name === '' ||
            OnlyNumberSpecialChar(offboardingTemplateDetails.name) == true
        ) {
            let error;
            if (
                OnlyNumberSpecialChar(offboardingTemplateDetails.name) == true &&
                (offboardingTemplateDetails.name != undefined || offboardingTemplateDetails.name != '')
            )
                error = 'Enter a valid Template Name';
            if (offboardingTemplateDetails.name === undefined || offboardingTemplateDetails.name === '')
                error = 'Template Name is required';
            setShowNavbar(false);
            setoffboardingTemplateErrors((offboardingTemplateErrors) => ({
                ...offboardingTemplateErrors,
                nameError: error,
            }));
            validate = false;
        }
        if (
            offboardingTemplateDetails.description === undefined ||
            offboardingTemplateDetails.description === '' ||
            OnlyNumberSpecialChar(offboardingTemplateDetails.description) == true
        ) {
            let error;
            if (
                OnlyNumberSpecialChar(offboardingTemplateDetails.description) == true &&
                (offboardingTemplateDetails.name != undefined || offboardingTemplateDetails.name != '')
            )
                error = 'Enter a valid Template Description';
            if (offboardingTemplateDetails.description === undefined || offboardingTemplateDetails.name === '')
                error = 'Template Description is required';
            setoffboardingTemplateErrors((offboardingTemplateErrors) => ({
                ...offboardingTemplateErrors,
                descriptionError: error,
            }));
            validate = false;
        }
        return validate;
    };

    return (
        <>
            <div className="offcanvas-header">
                <h5 className=" tt-bold font-16 announcement-offcanvas-color">
                    {editData?.name == undefined ? `New Template` : 'Edit Template'}
                </h5>
                <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss={'offcanvas'}
                    aria-label={'Close'}
                    onClick={() => {
                        resetData();
                    }}
                />
            </div>
            <div className="offcanvas-body">
                <div className="row">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-12 mb-4">
                                <label className="form-label font-12 bold-text announcement-offcanvas-color" htmlFor="Announcement-Title">
                                    Template Name
                                    <span className="required"> *</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control custom-textfield regular-text font-13"
                                    id="Announcement-Title"
                                    placeholder="Enter here"
                                    name="name"
                                    maxLength={30}
                                    value={offboardingTemplateDetails.name}
                                    onChange={(e) => {
                                        handleOffboardingTemplateForm(e);
                                        setShowNavbar(true);
                                        setoffboardingTemplateErrors((offboardingTemplateError) => ({
                                            ...offboardingTemplateError,
                                            nameError: '',
                                        }));
                                    }}
                                />
                                {offboardingTemplateError.nameError !== undefined || offboardingTemplateError.nameError !== '' ? (
                                    <span className="text-danger fs-6">{offboardingTemplateError.nameError}</span>
                                ) : null}
                            </div>
                            <div className="col-md-12 mb-4">
                                <label className="form-label font-12 bold-text announcement-offcanvas-color" htmlFor="Announcement-Title">
                                    Description
                                </label>
                                <span className="required"> *</span>

                                <textarea
                                    style={{ resize: 'none' }}
                                    ref={textarearef}
                                    onBlur={() => {
                                        textarearef.current.scrollTop = 0;
                                    }}
                                    className="form-control custom-textfield regular-text font-13 custom-comment-box"
                                    id="Announcement-Title"
                                    placeholder="Enter here"
                                    maxLength={255}
                                    name="description"
                                    value={offboardingTemplateDetails.description}
                                    onChange={(e) => {
                                        setoffboardingTemplateErrors((offboardingTemplateError) => ({
                                            ...offboardingTemplateError,
                                            descriptionError: '',
                                        }));
                                        setShowNavbar(true);
                                        handleOffboardingTemplateForm(e);
                                    }}
                                />
                                {offboardingTemplateError.descriptionError !== undefined ||
                                offboardingTemplateError.descriptionError !== '' ? (
                                    <span className="text-danger fs-6">{offboardingTemplateError.descriptionError}</span>
                                ) : null}
                            </div>
                        </div>
                        <div className="d-flex justify-content-end mb-4 mt-5 p-0 custom-button-position ">
                            <button
                                onClick={() => {
                                    resetData();
                                }}
                                className="btn hive-btn-secondary me-3"
                                data-bs-dismiss="offcanvas"
                                aria-label="Close"
                            >
                                Cancel
                            </button>

                            <button
                                onClick={() => {
                                    postOffboardingTeamplate();
                                }}
                                style={{ width: '100px' }}
                                className="btn medium-text font-14 primary-button me-3"
                                data-bs-dismiss={showNavbar == true ? 'offcanvas' : 'dummy'}
                                aria-label="Close"
                            >
                                {editData?.name == undefined ? `Add` : 'Update'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default OffboardingTemplateForm;
